import React, { Component, Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Redirect, Switch, Link } from "react-router-dom";
import environment from "environment";
import Analytics from "./Components/Global/Analytics";

import "./css/global.less";
import "./css/layout.less";

import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
// import DreamChimneyTopNav from "@dreamchimney/nav";

import SearchPage from "./Pages/SearchPage";
import ScrollToTop from "./Components/Global/ScrollToTop";
import DevBanner from "./Components/Global/DevBanner";
import SiteFooter from "./Components/Global/SiteFooter";

import { useUser, AuthWrapper } from "@dreamchimney/user-context";

const NoMatchPage = () => {
  return (
    <h3>
      Bummer. Page Not Found - <Link to="/">Back to Home</Link>
    </h3>
  );
  // return <Redirect to="/" />;
};

// @TODO
// Router basename
// Analytics basename

const App = () => {
  const { state: userState } = useUser();
  console.log("userState:", userState);

  return (
    <div className="dc-search">
      <DevBanner />

      <Router basename="/search">
        <AuthWrapper>
          <Container className="app-container" fluid={false}>
            <Row>
              <Col xs={12}>
                <div class="dc-search-logo">Dream Chimney: Search</div>

                <div className="middleWrapper">
                  <div className="mainSection">
                    <div className="contentPadding">
                      <Analytics basename="/search" local={process.env.CLIENT_ENV !== "production"}>
                        <ScrollToTop />

                        <Switch>
                          <Route exact path="/" name="home" component={SearchPage} />
                          <Route path="*">
                            <NoMatchPage />
                          </Route>
                        </Switch>
                      </Analytics>
                    </div>
                  </div>
                </div>
                <SiteFooter />
              </Col>
            </Row>
          </Container>
        </AuthWrapper>
      </Router>

      {/* <SiteFooter /> */}
    </div>
  );
};

export default App;
